// Use Cases — team-cell popovers: click/Enter toggles, one open at a time, outside click/Escape closes. Adapted from design source.
import jQuery from "jquery";

jQuery(function ($) {
	'use strict';

	$('[data-p360-uc-grid]').each(function () {
		var grid = this;
		var cells = [].slice.call(grid.querySelectorAll('.p360-uc__cell.has-card'));
		if (!cells.length) {
			return;
		}

		function close(except) {
			cells.forEach(function (c) {
				if (c === except) {
					return;
				}
				c.classList.remove('is-open');
				c.setAttribute('aria-expanded', 'false');
			});
		}

		function toggle(cell) {
			var open = !cell.classList.contains('is-open');
			close(cell);
			cell.classList.toggle('is-open', open);
			cell.setAttribute('aria-expanded', open ? 'true' : 'false');
		}

		cells.forEach(function (cell) {
			cell.addEventListener('click', function () {
				toggle(cell);
			});
			cell.addEventListener('keydown', function (e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					toggle(cell);
				}
				if (e.key === 'Escape') {
					close(null);
					cell.blur();
				}
			});
		});

		document.addEventListener('click', function (e) {
			if (!grid.contains(e.target)) {
				close(null);
			}
		});
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') {
				close(null);
			}
		});
	});
});